import { render, staticRenderFns, recyclableRender, components } from "./pageLoading.vue?vue&type=template&id=8b9eeb0a&scoped=true&"
var renderjs
import script from "./pageLoading.vue?vue&type=script&lang=js&"
export * from "./pageLoading.vue?vue&type=script&lang=js&"
import style0 from "./pageLoading.vue?vue&type=style&index=0&id=8b9eeb0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!D:\\Program Files\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9eeb0a",
  null,
  false,
  components,
  renderjs
)

export default component.exports